var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyDoWeNeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61551 5.99507V3.46382C8.61551 1.55428 7.00298 0 5.02187 0C3.04077 0 1.42824 1.55428 1.42824 3.46382V5.99507C0.645011 5.99507 0 6.61678 0 7.37171V12.8339C0 13.5888 0.645011 14.2105 1.42824 14.2105H8.56944C9.35266 14.2105 9.99768 13.5888 9.99768 12.8339V7.37171C10.0437 6.61678 9.39874 5.99507 8.61551 5.99507ZM2.34968 3.46382C2.34968 2.04276 3.54756 0.888158 5.02187 0.888158C6.49619 0.888158 7.69406 2.04276 7.69406 3.46382V5.99507H2.34968V3.46382ZM5.4826 11.324V11.0576C6.03546 10.8355 6.40404 10.347 6.40404 9.81415C6.40404 9.05921 5.8051 8.48191 5.02187 8.48191C4.23865 8.48191 3.63971 9.05921 3.63971 9.81415C3.63971 10.3914 4.00828 10.8799 4.56115 11.0576V11.324C4.56115 11.5905 4.74544 11.7681 5.02187 11.7681C5.29831 11.7681 5.4826 11.5905 5.4826 11.324Z",
    fill: "#000A2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyDoWeNeed);
export default __webpack_public_path__ + "static/media/why_do_we_need.d8c95902d339e1bf4ec06640e305647d.svg";
export { ForwardRef as ReactComponent };